<div class="flex flex-col">
    <button mat-button (click)="onSearch()" [matMenuTriggerFor]="menu"
        class="w-full p-2 border rounded-lg flex items-center justify-between">
        <mat-icon [svgIcon]="selectedIcon" class="text-primary"></mat-icon>
    </button>
    <mat-menu #menu="matMenu" class="h-100">
        <div class="w-full px-5 py-2">
            <input 
                type="text" 
                class="w-full rounded-md px-4 py-2 ring-2 ring-primary dark:bg-dashboard-200" 
                [(ngModel)]="filter" 
                (ngModelChange)="onSearch()"
                (click)="$event.stopPropagation()"
            >
        </div>
        <div #iconContainer (scroll)="onScroll($event)"
            class="grid grid-cols-5 p-2 text-center justify-center items-center overflow-auto max-h-80">
            <button *ngFor="let icon of visibleIcons" mat-icon-button (click)="onIconSelect(icon)"
                class="hover:bg-primary/10 p-3 rounded-lg overflow-hidden flex justify-center items-center">
                <mat-icon [svgIcon]="icon" class="text-primary"></mat-icon>
            </button>
        </div>
    </mat-menu>
</div>